/** @file readFacingSteps: body facing steps per turn, an integer 1-360 or `free` (design 17.3). */
import { checkNumber } from '@zilo/pose3d-format/validate/fields/checkNumber';

const steps = checkNumber({ int: true, min: 1, max: 360 });

/** `value` when it is `'free'` or an integer in [1, 360]; else `VALIDATION` at `path`. */
export function readFacingSteps(value: unknown, path: string): number | 'free' {
  if (value === 'free') return 'free';
  steps(value, path);
  return value as number;
}
